import { sum } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GraphStackResponse } from 'src/api/gen'
import { DatasetCategory } from 'src/commons/chartjs'
import ComparisonPlot from 'src/commons/graphs/ComparisonPlot'
import StackedHistogram from 'src/commons/graphs/StackedHistogram'
import TemporalHistogram from 'src/commons/graphs/TemporalHistogram'
import { getTranslation } from 'src/commons/i18n'
import { IGraphBucketWithTotal, IGraphCompareWithTotal, IGraphStack } from 'src/commons/types'
import { formatNumber, getDocCountSum } from 'src/commons/utils'

function getTotal(data: GraphStackResponse[]) {
  return sum(
    data.map((item) => {
      return getDocCountSum(item.stackedBy.buckets)
    })
  )
}

export function UniqueUserPerDay(props: IGraphBucketWithTotal) {
  const { t } = getTranslation()
  return (
    <TemporalHistogram
      showTitle
      title={`${t('kpi.user.total')}: ${props.graphReport.total ? formatNumber(props.graphReport.total) : ''}`}
      rawData={props.graphReport.data ?? ([] as any)}
      granularity={props.granularity}
      enableAnimation={props.enableAnimation}
    />
  )
}
export function UserPerTripsPerformed(props: IGraphStack) {
  const total = getTotal(props.graphReport)
  const { t } = useTranslation()

  return (
    <StackedHistogram
      showTitle
      title={`${t('kpi.user.total')}: ${formatNumber(total)}`}
      rawData={props.graphReport}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function UniqueUserPerProvider(props: IGraphCompareWithTotal) {
  const { t } = getTranslation()
  return (
    <ComparisonPlot
      showTitle
      title={`${t('kpi.user.total')}: ${props.graphReport.total ? formatNumber(props.graphReport.total) : ''}`}
      rawData={props.graphReport.data ? props.graphReport.data : ([] as any)}
      granularity={props.granularity}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}
